import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";

import { logout } from "../../actions/auth";
import { Logo } from "../Logo";
import "./NavBar.scss";

class NavBar extends React.Component {
  state = { currentTab: this.props.location.pathname };

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location)
      this.setState({ currentTab: this.props.location.pathname });
  }

  render() {
    const NavLink = ({ to, children }) => (
      <Link
        className="navLink disable-select"
        to={to}
        style={{
          fontWeight:
            this.state.currentTab.indexOf(to) !== -1 ? "bold" : "initial",
          color:
            this.state.currentTab.indexOf(to) !== -1
              ? "rgba(0, 0, 0, 0.7)"
              : "rgba(0, 0, 0, 0.5)"
        }}
      >
        {children}
      </Link>
    );

    return (
      <Navbar id="navbar" expand="lg" fixed="top">
        <Navbar.Brand style={{ paddingLeft: "5%" }}>
          <Logo />
        </Navbar.Brand>
        {this.props.dashboard ? (
          <div
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "space-between"
            }}
          >
            {this.props.location.pathname.indexOf("packages") !== -1 ? (
              <div className="searchInput">
                <IoIosSearch size={24} color="#555C64" />
                <input
                  placeholder="Search orders and lockers"
                  type="search"
                  onChange={this.props.onSearchChange}
                />
              </div>
            ) : (
              <div style={{ flex: 1 }} />
            )}
            <Navbar.Collapse
              id="basic-navbar-nav"
              style={{ flex: "0 0 auto", height: "auto!important" }}
            >
              <Nav className="navLinks">
                <NavLink to="/packages">My Packages</NavLink>
                <NavLink to="/lockers">Lockers</NavLink>
                <NavLink to="/coupons">Coupons</NavLink>
                <NavLink to="/refer">Refer Friends</NavLink>
                <NavLink to="/help">Help</NavLink>
                <NavDropdown
                  title={
                    (this.props.userData.account &&
                      this.props.userData.account.name) ||
                    "Account"
                  }
                  className="navDropDown"
                  id="basic-nav-dropdown"
                  style={{
                    fontWeight:
                      this.state.currentTab.indexOf("account") !== -1
                        ? "bold"
                        : "initial",
                    color:
                      this.state.currentTab.indexOf("account") !== -1
                        ? "rgba(0, 0, 0, 0.7)"
                        : "rgba(0, 0, 0, 0.5)"
                  }}
                >
                  <Link to="/account" className="dropdown-item">
                    <div className="logoutBtn">Account</div>
                  </Link>
                  <button className="dropdown-item" onClick={this.props.logout}>
                    <div className="logoutBtn">Log Out</div>
                  </button>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              style={{
                height: "fit-content",
                alignSelf: "center"
              }}
            />
          </div>
        ) : (
          <Nav className="navLinks signUp">
            <button onClick={() => this.props.onButtonClick("signup")}>
              Sign Up
            </button>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <button
              onClick={() => this.props.onButtonClick("login")}
              style={{ fontWeight: "bold" }}
            >
              Log In
            </button>
          </Nav>
        )}
      </Navbar>
    );

    // return (
    //   <nav id="navbar">
    //     <div className="logoContainer">
    //       <Link to="/">
    //         <img
    //           src={require("../../assets/logo/logo-text-horizontal.png")}
    //           alt="logo"
    //         />
    //       </Link>
    //     </div>

    //     {this.props.dashboard ? (
    //       <div id="dashButtons">
    //         {this.props.location.pathname.indexOf("packages") !== -1 ? (
    //           <div className="searchInput">
    //             <IoIosSearch size={24} color="#555C64" />
    //             <input
    //               placeholder="Search orders and lockers"
    //               type="search"
    //               onChange={this.props.onSearchChange}
    //             />
    //           </div>
    //         ) : (
    //           <div />
    //         )}
    //         <div style={{ alignSelf: "center" }}>
    //           <NavLink to="/packages">My Packages</NavLink>
    //           <NavLink to="/lockers">Lockers</NavLink>
    //           <NavLink to="/refer">Refer Friends</NavLink>
    //           <NavLink to="/help">Help</NavLink>
    //           <div className="navDropDown">
    //             <button
    //               className="dropBtn"
    //               style={{
    //                 fontWeight:
    //                   this.state.currentTab.indexOf("account") !== -1
    //                     ? "bold"
    //                     : "initial"
    //               }}
    //             >
    //               {this.props.userData.account.name || "Account"}{" "}
    //               <FaCaretDown />
    //             </button>
    //             <div className="navDropDownContent">
    //               <NavLink to="/account">
    //                 <div className="navDropDownItem">Account</div>
    //               </NavLink>
    //               <button className="logoutBtn" onClick={this.handleLogout}>
    //                 Log Out
    //               </button>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     ) : (
    //       <div className="signUp">
    //         <button onClick={() => this.props.onButtonClick("signup")}>
    //           Sign Up
    //         </button>
    //         &nbsp;&nbsp;|&nbsp;&nbsp;
    //         <button
    //           onClick={() => this.props.onButtonClick("login")}
    //           style={{ fontWeight: "bold" }}
    //         >
    //           Log In
    //         </button>
    //       </div>
    //     )}
    //   </nav>
    // );
  }
}

NavBar.propTypes = {
  onButtonClick: PropTypes.func,
  dashboard: PropTypes.bool,
  onSearchChange: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout())
});

const mapStateToProps = state => ({
  ...state
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(NavBar)
);
